import { render, staticRenderFns } from "./ProjectsListTable.vue?vue&type=template&id=21506cfa&scoped=true&"
import script from "./ProjectsListTable.vue?vue&type=script&lang=js&"
export * from "./ProjectsListTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsListTable.vue?vue&type=style&index=0&id=21506cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21506cfa",
  null
  
)

export default component.exports